import React from 'react';
import { useTranslation } from 'react-i18next';
import { THEME_DARK, THEME_LIGHT, THEME_SYSTEM, useTheme } from '@/theme/ThemeProvider';

// Cycles System → Light → Dark → System, the same three states the phone apps
// offer (ThemeID 0/1/2). A cycle rather than a menu because it is one control in
// a crowded header and the current state is visible in the page itself.
export const ThemeToggle: React.FC = () => {
    const { t } = useTranslation();
    const { themeID, setThemeID } = useTheme();

    const next = themeID === THEME_SYSTEM ? THEME_LIGHT
        : themeID === THEME_LIGHT ? THEME_DARK
            : THEME_SYSTEM;

    const label = themeID === THEME_SYSTEM ? t('web.nav.themeSystem')
        : themeID === THEME_LIGHT ? t('web.nav.themeLight')
            : t('web.nav.themeDark');

    const glyph = themeID === THEME_SYSTEM ? '◐' : themeID === THEME_LIGHT ? '☀' : '☾';

    return (
        <button
            type="button"
            className="iconbtn"
            onClick={() => setThemeID(next)}
            aria-label={`${t('web.nav.theme')}: ${label}`}
            title={`${t('web.nav.theme')}: ${label}`}
        >
            <span aria-hidden="true">{glyph}</span>
        </button>
    );
};
